// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PorticoDataValueModel {
    'id'?: string;
    'dataRowId'?: string;
    'dataColumnId'?: string;
    'value'?: string;
    'createdBy'?: number;
    'createdOn'?: Moment;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PorticoDataValueModel>> = [
        {
            "name":     "id",
            "baseName": "id",
            "type":     "string"
        },
        {
            "name":     "dataRowId",
            "baseName": "dataRowId",
            "type":     "string"
        },
        {
            "name":     "dataColumnId",
            "baseName": "dataColumnId",
            "type":     "string"
        },
        {
            "name":     "value",
            "baseName": "value",
            "type":     "string"
        },
        {
            "name":     "createdBy",
            "baseName": "createdBy",
            "type":     "number"
        },
        {
            "name":     "createdOn",
            "baseName": "createdOn",
            "type":     "Date"
        },
    ];

    static getAttributeTypeMap() {
        return PorticoDataValueModel.attributeTypeMap;
    }
}
